module.exports = __webpack_public_path__ + "static/media/zoomy7.76c95125.jpg";